import { useState, useEffect } from "react";

import { useFormikContext } from "formik";
import { Profile } from "neetoteam";
import { Button, Typography, Tooltip } from "neetoui";
import { useTranslation } from "react-i18next";

import MoreDropdown from "components/MoreDropdown";

import { getTimeZoneAndTime } from "./utils";

const Header = ({
  isCreating,
  isEditable,
  isEditing,
  setIsEditing,
  showTimeZone = true,
}) => {
  const { dirty, resetForm, submitForm, isSubmitting } = useFormikContext();
  const { t } = useTranslation();
  const [timeZoneAndTime, setTimeZoneAndTime] = useState(getTimeZoneAndTime());
  const [_, setIsProfilePaneOpen] = Profile.usePaneState();

  const handleReset = () => {
    if (dirty) resetForm();
    else setIsEditing(false);
  };

  useEffect(() => {
    const time = setInterval(() => {
      setTimeZoneAndTime(getTimeZoneAndTime());
    }, 30000);

    return () => clearInterval(time);
  }, []);

  return (
    <div className="mb-6 flex flex-wrap justify-between gap-2">
      {showTimeZone && (
        <div
          className="flex items-center gap-3"
          data-testid="schedule-timezone-header"
        >
          <Tooltip
            content={t("neetoMolecules.schedule.timezoneTooltip")}
            position="bottom"
            touch={["hold", 500]}
          >
            <Typography
              component="h4"
              data-testid="timezone-text"
              style="h5"
              weight="medium"
            >
              {timeZoneAndTime}
            </Typography>
          </Tooltip>
          {isEditable && (
            <MoreDropdown
              dropdownButtonProps={{ "data-testid": "nui-more-dropdown" }}
              menuItems={[
                {
                  onClick: () => setIsProfilePaneOpen(true),
                  label: t("neetoMolecules.common.actions.changeTimezone"),
                  target: "_blank",
                  key: "change-timezone-option",
                  "data-testid": "change-timezone-option",
                },
              ]}
            />
          )}
        </div>
      )}
      {isEditing ? (
        <div className="flex items-center gap-2">
          <Button
            data-testid="reset-button"
            style="secondary"
            label={
              !dirty
                ? t("neetoMolecules.common.actions.cancel")
                : t("neetoMolecules.common.actions.reset")
            }
            onClick={handleReset}
          />
          <Button
            data-testid="weekly-hours-save-changes-button"
            disabled={(!dirty && !isCreating) || isSubmitting}
            label={t("neetoMolecules.common.actions.saveChanges")}
            loading={isSubmitting}
            onClick={submitForm}
          />
        </div>
      ) : (
        isEditable && (
          <div>
            <Button
              data-testid="weekly-schedule-header"
              label={t("neetoMolecules.schedule.changeAvailability")}
              style="primary"
              weight="semibold"
              onClick={() => setIsEditing(true)}
            />
          </div>
        )
      )}
    </div>
  );
};

export default Header;
